import React, { Component } from 'react';
import PropTypes from 'prop-types';
import texts from '../texts/messages';

export default class MessageBox extends Component {

    static propTypes = {
        lang: PropTypes.string.isRequired,
        mKey: PropTypes.string.isRequired,
        mType: PropTypes.string.isRequired,
        mIcon: PropTypes.string.isRequired
    };

    render() {
        let text = texts[this.props.lang];

        return (
             <div className={'alert alert-' + this.props.mType}>
                <span className={'glyphicon glyphicon-' + this.props.mIcon} aria-hidden="true"></span>
                <span className="sr-only">Error:</span>
                &nbsp;{text[this.props.mKey]}
              </div>
            );
  }
}
